import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=113b87bb&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113b87bb')) {
      api.createRecord('113b87bb', component.options)
    } else {
      api.reload('113b87bb', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=113b87bb&", function () {
      api.rerender('113b87bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/employees/Index.vue"
export default component.exports